import './MenuSeparator.css';

interface MenuSeparatorProps {
  label?: string | undefined;
}

const MenuSeparator = ({ label }: MenuSeparatorProps) => (
  <div className="menu-separator">
    {label && (
      <div>
        <span>{label}</span>
      </div>
    )}
    <hr />
  </div>
);

export default MenuSeparator;
